var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Text, spacer16, spacer24, spacer12, } from '@spotify-internal/encore-web';
import { TextLink } from '../../../../../LinkV2';
import { trackCat } from '../../../../constants';
import { TWO_COLUMN_MAX_WIDTH } from '../../Grid';
import { fadeInAnimation } from '../../../../fadeInAnimation';
import { useActiveSubmenuContext } from '../../../../../ActiveSubmenu/ActiveSubmenuProvider';
var sanitizeEyebrow = function (eyebrow) {
    var LENGTH_LIMIT = 25;
    if (eyebrow.length > LENGTH_LIMIT) {
        console.error("CategoryLinkList: eyebrow exceeded maximum threshold of ".concat(LENGTH_LIMIT));
    }
    return eyebrow.substring(0, LENGTH_LIMIT);
};
var sanitizeCategoryLinks = function (categoryLinks) {
    var ITEM_LIMIT = 7;
    var LINK_LENGTH_LIMIT = 20;
    if (categoryLinks.length > ITEM_LIMIT) {
        console.error("CategoryLinkList: categoryLinks exceeded maximum threshold of ".concat(ITEM_LIMIT));
    }
    return categoryLinks
        .filter(function (_, i) { return i < ITEM_LIMIT; })
        .map(function (link) {
        if (link.label.length > LINK_LENGTH_LIMIT) {
            console.error("CategoryLinkList: link label exceeded maximum threshold of ".concat(LINK_LENGTH_LIMIT));
        }
        return __assign(__assign({}, link), { label: link.label.substring(0, LINK_LENGTH_LIMIT) });
    });
};
var CategoryLinkListSection = styled.section.withConfig({
    shouldForwardProp: function (prop) { return !['delay'].includes(prop); }
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    ", "\n  }\n\n  & nav {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-top: ", ";\n\n    & li {\n      margin-bottom: ", ";\n      @media (max-width: 1399px) {\n        margin-bottom: ", ";\n      }\n      @media (max-width: ", ") {\n        margin-bottom: ", ";\n      }\n    }\n\n    & li:first-of-type {\n      margin-bottom: ", ";\n      @media ((min-width: 1400px) or (max-width: ", ")) {\n        // override text variant size\n        button,\n        a {\n          span {\n            font-size: 32px;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  @media (max-width: ", ") {\n    ", "\n  }\n\n  & nav {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-top: ", ";\n\n    & li {\n      margin-bottom: ", ";\n      @media (max-width: 1399px) {\n        margin-bottom: ", ";\n      }\n      @media (max-width: ", ") {\n        margin-bottom: ", ";\n      }\n    }\n\n    & li:first-of-type {\n      margin-bottom: ", ";\n      @media ((min-width: 1400px) or (max-width: ", ")) {\n        // override text variant size\n        button,\n        a {\n          span {\n            font-size: 32px;\n          }\n        }\n      }\n    }\n  }\n"])), TWO_COLUMN_MAX_WIDTH, function (_a) {
    var delay = _a.delay;
    return delay && fadeInAnimation(delay);
}, spacer24, spacer12, spacer12, TWO_COLUMN_MAX_WIDTH, spacer16, spacer16, TWO_COLUMN_MAX_WIDTH);
var EyebrowLabel = styled(Text).attrs({
    variant: 'bodyMedium',
    semanticColor: 'textSubdued'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var CategoryLinkList = function (_a) {
    var eyebrow = _a.eyebrow, categoryLink = _a.categoryLink, _b = _a.subLinks, subLinks = _b === void 0 ? [] : _b, delay = _a.delay, _c = _a.onNavigate, onNavigate = _c === void 0 ? function () { } : _c;
    var clearActiveSubmenu = useActiveSubmenuContext().clearActiveSubmenu;
    var sanitizedEyebrow = sanitizeEyebrow(eyebrow);
    var sanitizedCategoryLink = sanitizeCategoryLinks([categoryLink]);
    var sanitizedSubLinks = sanitizeCategoryLinks(subLinks);
    var _d = useState(window.matchMedia("(max-width: ".concat(TWO_COLUMN_MAX_WIDTH, ")")).matches), isSmallScreen = _d[0], setIsSmallScreen = _d[1];
    var onClick = useCallback(function (x) {
        onNavigate();
        clearActiveSubmenu(x);
    }, [clearActiveSubmenu, onNavigate]);
    useEffect(function () {
        var mediaQuery = window.matchMedia("(max-width: ".concat(TWO_COLUMN_MAX_WIDTH, ")"));
        var handleResize = function () { return setIsSmallScreen(mediaQuery.matches); };
        mediaQuery.addListener(handleResize);
        return function () { return mediaQuery.removeListener(handleResize); };
    }, []);
    return (React.createElement(CategoryLinkListSection, { delay: delay },
        React.createElement(EyebrowLabel, null, sanitizedEyebrow),
        React.createElement("nav", null,
            React.createElement("li", { key: 0 },
                React.createElement(TextLink, __assign({ onClick: onClick, size: isSmallScreen ? 'large' : 'medium' }, sanitizedCategoryLink[0], { trackingCategory: trackCat }))),
            sanitizedSubLinks.map(function (link, index) { return (React.createElement("li", { key: index + 1 },
                React.createElement(TextLink, __assign({ onClick: onClick, size: isSmallScreen ? 'medium' : 'small' }, link, { trackingCategory: trackCat })))); }))));
};
var templateObject_1, templateObject_2;
